import styled from "styled-components";
import MaskedInput from "react-maskinput";

export const Container = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Form = styled.form`
  width: 100%;
  padding: 1rem;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  background: #ffffff;
  box-shadow: 20px 20px 60px #d9d9d9, -20px -20px 60px #f4f4f4;

  h2 {
    font-size: 1.1rem;
    text-transform: uppercase;
    margin-top: 10px;
    margin-bottom: 15px;
    text-align: right;
    color: #a6a49f;
    border-bottom: 1px solid #a6a49f;
  }

  @media (min-width: 700px) {
    width: 60%;
  }

  @media (min-width: 1024px) {
    width: 50%;
  }
`;

export const Group = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 5px;
`;

export const Input = styled.input`
  width: 100%;
  height: 2rem;
  padding: 0.5rem;
  border: 1px solid #cecece;
  border-radius: 5px;
  outline: 0;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: #cccac3;
  }
  :-ms-input-placeholder {
    color: #cccac3;
  }
`;

export const Masked = styled(MaskedInput)`
  width: 100%;
  height: 2rem;
  padding: 0.5rem;
  border: 1px solid #cecece;
  border-radius: 5px;
  outline: 0;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: #cccac3;
  }
  :-ms-input-placeholder {
    color: #cccac3;
  }
`;

export const Select = styled.select`
  width: 100%;
  height: 3rem;
  padding: 0.5rem;
  border: none;
  border-radius: 5px;
  outline: 0;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 0.5rem;
  border: none;
  border-radius: 5px;
  outline: 0;
  border: 1px solid #cecece;
  border-radius: 5px;
  outline: 0;
  ::placeholder,
  ::-webkit-input-placeholder {
    color: #cccac3;
  }
  :-ms-input-placeholder {
    color: #cccac3;
  }
`;

export const Button = styled.button`
  width: 100%;
  height: 3rem;
  padding: 0.5rem;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  color: #fff;
  background: #2f3d40;
  outline: none;
  transition: all 0.5s ease;
  &:hover {
    background: #182625;
  }
`;

export const ButtonSecondary = styled(Button)`
  background: #f08603;
  &:hover {
    background: #f4a103;
  }
`;
